import React, { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { getNotificationId } from "../../utils/adminNotificationUtils";

const AdminNotificationToast = ({ data, onClose, onOpen }) => {
    const [visible, setVisible] = useState(false);
    const id = getNotificationId(data);

    useEffect(() => {
        setVisible(true);
        let closingTimer;
        const timer = setTimeout(() => {
            setVisible(false);
            closingTimer = setTimeout(() => onClose(id), 240);
        }, 5000);
        return () => {
            clearTimeout(timer);
            clearTimeout(closingTimer);
        };
    }, [id, onClose]);

    return (
        <div className={"admin-notification-toast " + (visible ? "show" : "hide")}>
            <button type="button" className="admin-notification-toast__content" onClick={() => onOpen(data)}>
                <strong>{data.title}</strong>
                <span>{data.message}</span>
            </button>
            <button type="button" className="admin-notification-toast__close" aria-label="Скрыть уведомление" onClick={() => onClose(id)}>
                <CloseIcon fontSize="small" />
            </button>
        </div>
    );
};

export default AdminNotificationToast;
